import { useEffect, useRef, useState } from 'react';

const CHECK_INTERVAL = 5 * 60 * 1000; // 5 minutes
const currentVersion = process.env.REACT_APP_BUILD_VERSION;

declare global {
  interface Window {
    __FORCE_VERSION_BANNER__?: boolean;
  }
}

const useVersionCheck = () => {
  const [newVersionAvailable, setNewVersionAvailable] = useState(false);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    if (window.__FORCE_VERSION_BANNER__) {
      setNewVersionAvailable(true);
      return;
    }

    if (!currentVersion) return;

    const checkVersion = async () => {
      try {
        const res = await fetch(`/version.json?t=${Date.now()}`);
        if (!res.ok) return;
        const data = await res.json();
        if (data.version && data.version !== currentVersion) {
          setNewVersionAvailable(true);
          if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
          }
        }
      } catch {
        // silently ignore fetch errors
      }
    };

    intervalRef.current = setInterval(checkVersion, CHECK_INTERVAL);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  return newVersionAvailable;
};

export default useVersionCheck;
